import { useEffect } from "react";
import { useAlert } from "../../../../src/context/AlertContext";
import { ALERT_ERROR } from "../../../components/iconsSVG/IconsSVG";
import { AlertRenderer } from "../../../../src/components/alert/AlertRenderer";
import { Link } from "react-router-dom";
import {VOLVER} from "../../../components/iconsSVG/IconsSVG.jsx";

const SuscripcionCanceladaError = () => {

  const { showAlert } = useAlert(); // obtenemos la función del contexto

  useEffect(() => {
    showAlert({
      tipo: "error",
      titulo: "Error",
      msg: "El enlace ha expirado o se ha producido un error.",
      customIcon: <ALERT_ERROR/>
    });
  }, [showAlert]); // solo se ejecuta una vez al montar  

  return (   
    <div className="p-0 m-2">
    <div className="m-2 p-0 d-flex justify-content-end">
      <Link to="/buscador" className="btn m-0 p-0 me-3 btn-volver text-end">
        <VOLVER strokeWidth={1.5} width={"24px"} height={"16px"}/>{" "} VOLVER A CONSULTA BOPI
      </Link>
    </div>
        <br></br>
        <h4>Verificación de baja del Boletín Oficial de la Propiedad Industrial</h4>      
        {/* ESTO ES PARA MOSTRAR LA ALERTA */}
        <AlertRenderer />

        <p> 
          Por favor, solicite la baja de nuevo {" "} <a href="/bopi/subscripcion-boletin">aquí</a>.
          </p>
      </div>
    );
};

export default SuscripcionCanceladaError;